<template>
    <section class="content">
        <div class="row">
            <div class="col-md-12">
                <div class="box box-primary">
                    <div class="box-header with-border">
                        <h3 class="box-title">
                            <b>{{ $route.meta.description }}</b>

                        </h3>
                    </div>
                    <div class="box-body">
                        <form style="width:100%" method="POST" @submit.prevent="commit" ref="usuario">
                            <div class="row">
                                <div class="col-sm-4">
                                    <div :class="{ 'form-group': true, 'has-error': errors.has('nome') }">
                                        <label for="nome">Nome Completo</label>
                                        <input class="form-control" name="nome" type="text" v-model="dados.name" v-validate="'required'" />
                                        <span v-show="errors.has('nome')" class="help-block">{{ errors.first("nome") }}</span>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div :class="{ 'form-group': true, 'has-error': errors.has('email') }">
                                        <label for="email">Email</label>
                                        <input class="form-control" name="email" type="text" v-model="dados.email" v-validate="'required|email'" style="text-transform:none !important" />
                                        <span v-show="errors.has('email')" class="help-block">{{ errors.first("email") }}</span>
                                    </div>
                                </div>
                                <div class="col-sm-2">
                                    <div :class="{ 'form-group': true }">
                                        <label for="telefone">Telefone</label>
                                        <input v-mask="['(##)#####-####', '(##)####-####']" class="form-control" name="telefone" type="text" v-model="dados.telefone" />
                                    </div>
                                </div>
                                <div class="col-sm-2">
                                    <div :class="{ 'form-group': true, 'has-error': errors.has('nivel') }">
                                        <label for="nivel">Perfil:</label>
                                        <select class="form-control" name="nivel" type="text" v-model="dados.nivel" :disabled="atualizacao">
                                            <option value>--Selecione--</option>
                                            <option value="administrador">Administrador</option>
                                            <option value="regulador">Regulador</option>
                                            <option value="marcador">Marcador</option>
                                            <option value="prestador">Prestador</option>
                                        </select>
                                        <span v-show="errors.has('nivel')" class="help-block">{{ errors.first("nivel") }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-4">
                                    <div :class="{ 'form-group': true, 'has-error': errors.has('usuario') }">
                                        <label for="usuario">Usuário</label>
                                        <input class="form-control" name="usuario" type="text" v-model="dados.login" v-validate="'required'" style="text-transform:none !important" />
                                        <span v-show="errors.has('usuario')" class="help-block">{{ errors.first("usuario") }}</span>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div :class="{ 'form-group': true, 'has-error': errors.has('senha') }">
                                        <label for="senha">Senha</label>
                                        <input class="form-control" name="senha" type="password" v-model="dados.password" v-validate="{ required: !atualizacao }" style="text-transform:none !important"  />
                                        <span v-show="errors.has('senha')" class="help-block">{{ errors.first("senha") }}</span>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div :class="{ 'form-group': true, 'has-error': errors.has('confirmacaoSenha') }">
                                        <label for="confirmacaoSenha">Redigite a Senha</label>
                                        <input class="form-control" name="confirmacaoSenha" type="password" v-model="confirmacaoSenha" v-validate="{ required: !atualizacao, is: dados.password }" style="text-transform:none !important" />
                                        <span v-show="errors.has('confirmacaoSenha')" class="help-block">{{ errors.first("confirmacaoSenha") }}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <label>Unidades Vinculadas</label>
                                        <v-select id="select-dias" placeholder="Clique para selecionar a(s) unidade(s)..." multiple v-model="dados.unidades" :options="selectUnidades"></v-select>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <label for="anotacoes">Anotações</label>
										<textarea v-model="dados.anotacoes" class="form-control" name="anotacoes" id="" cols="30" rows="10"></textarea>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-12">
                                    <label>Permissões do Usuário</label>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="box box-solid collapsed-box" style="font-size:12px;">
                                        <div class="box-header with-border">
                                            <h3 class="box-title">Administração</h3>
                                            <div class="box-tools pull-right">
                                                <button type="button" class="btn btn-box-tool" data-widget="collapse">
                                                    <i class="fa fa-plus"></i>
                                                </button>
                                            </div>
                                        </div>
                                        <!-- /.box-header -->
                                        <div class="box-body">
                                            <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped">
                                                <thead>
                                                    <tr role="row">
                                                        <th style="width: 80%">Funcionalidade</th>
                                                        <th style="width: 10%">Ativar</th>
                                                        <th style="width: 10%">Atualizar Dados</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr class="even" role="row">
                                                        <td>CONTRATOS</td>
                                                        <td>
                                                            <label class="container-checks">
                                                                <input type="checkbox" v-model="dados.permissoes" value="contrato.read" @click="() => {}" />
                                                                <span class="checkmark"></span>
                                                            </label>
                                                        </td>
                                                        <td>
                                                            <label class="container-checks">
                                                                <input type="checkbox" v-model="dados.permissoes" value="contrato.write" @click="() => {}" />
                                                                <span class="checkmark"></span>
                                                            </label>
                                                        </td>
                                                    </tr>
                                                    <tr class="even" role="row">
                                                        <td>AGENDA</td>
                                                        <td>
                                                            <label class="container-checks">
                                                                <input type="checkbox" v-model="dados.permissoes" value="agenda.read" @click="() => {}" />
                                                                <span class="checkmark"></span>
                                                            </label>
                                                        </td>
                                                        <td>
                                                            <label class="container-checks">
                                                                <input type="checkbox" v-model="dados.permissoes" value="agenda.write" @click="() => {}" />
                                                                <span class="checkmark"></span>
                                                            </label>
                                                        </td>
                                                    </tr>

                                                    <tr class="even" role="row">
                                                        <td>RELATÓRIO DE SOLICITAÇÕES</td>
                                                        <td>
                                                            <label class="container-checks">
                                                                <input type="checkbox" v-model="dados.permissoes" value="relatorio.solicitacao" @click="() => {}" />
                                                                <span class="checkmark"></span>
                                                            </label>
                                                        </td>
                                                        <td></td>
                                                    </tr>

                                                    <tr class="even" role="row">
                                                        <td>RELATÓRIO DE ESCALAS</td>
                                                        <td>
                                                            <label class="container-checks">
                                                                <input type="checkbox" v-model="dados.permissoes" value="relatorio.escalas" @click="() => {}" />
                                                                <span class="checkmark"></span>
                                                            </label>
                                                        </td>
                                                        <td></td>
                                                    </tr>

                                                    <tr class="even" role="row">
                                                        <td>RELATÓRIO DE OFERTAS DE PROCEDIMENTO</td>
                                                        <td>
                                                            <label class="container-checks">
                                                                <input type="checkbox" v-model="dados.permissoes" value="relatorio.ofertas" @click="() => {}" />
                                                                <span class="checkmark"></span>
                                                            </label>
                                                        </td>
                                                        <td></td>
                                                    </tr>

                                                    <tr class="even" role="row">
                                                        <td>RELAÇÃO DE USUÁRIOS</td>
                                                        <td>
                                                            <label class="container-checks">
                                                                <input type="checkbox" v-model="dados.permissoes" value="relatorio.usuarios" @click="() => {}" />
                                                                <span class="checkmark"></span>
                                                            </label>
                                                        </td>
                                                        <td></td>
                                                    </tr>

                                                     <tr class="even" role="row">
                                                        <td>RELATÓRIO AGENDA DO PRESTADOR</td>
                                                        <td>
                                                            <label class="container-checks">
                                                                <input type="checkbox" v-model="dados.permissoes" value="relatorio.agenda.prestador" @click="() => {}" />
                                                                <span class="checkmark"></span>
                                                            </label>
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <!-- /.box-body -->
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="box box-solid collapsed-box" style="font-size:12px;">
                                        <div class="box-header with-border">
                                            <h3 class="box-title">Distribuição</h3>
                                            <div class="box-tools pull-right">
                                                <button type="button" class="btn btn-box-tool" data-widget="collapse">
                                                    -
                                                    <i class="fa fa-plus"></i>
                                                </button>
                                            </div>
                                        </div>
                                        <!-- /.box-header -->
                                        <div class="box-body">
                                            <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped">
                                                <thead>
                                                    <tr role="row">
                                                        <th style="width: 80%">Funcionalidade</th>
                                                        <th style="width: 10%">Ativar</th>
                                                        <th style="width: 10%">Atualizar Dados</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr class="even" role="row">
                                                        <td>DISTRIBUIR</td>
                                                        <td>
                                                            <label class="container-checks">
                                                                <input type="checkbox" v-model="dados.permissoes" value="distribuicao.write" @click="() => {}" />
                                                                <span class="checkmark"></span>
                                                            </label>
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                    <tr class="even" role="row">
                                                        <td>CONTROLE DE CONTRATOS</td>
                                                        <td>
                                                            <label class="container-checks">
                                                                <input type="checkbox" v-model="dados.permissoes" value="distribuicao.contrato.read" @click="() => {}" />
                                                                <span class="checkmark"></span>
                                                            </label>
                                                        </td>
                                                        <td>
                                                            <label class="container-checks">
                                                                <input type="checkbox" v-model="dados.permissoes" value="distribuicao.contrato.write" @click="() => {}" />
                                                                <span class="checkmark"></span>
                                                            </label>
                                                        </td>
                                                    </tr>

                                                    <tr class="even" role="row">
                                                        <td>CONTROLE DA AGENDA</td>
                                                        <td>
                                                            <label class="container-checks">
                                                                <input type="checkbox" v-model="dados.permissoes" value="distribuicao.agenda.read" @click="() => {}" />
                                                                <span class="checkmark"></span>
                                                            </label>
                                                        </td>
                                                        <td>
                                                            <label class="container-checks">
                                                                <input type="checkbox" v-model="dados.permissoes" value="distribuicao.agenda.write" @click="() => {}" />
                                                                <span class="checkmark"></span>
                                                            </label>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <!-- /.box-body -->
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="box box-solid collapsed-box" style="font-size:12px;">
                                        <div class="box-header with-border">
                                            <h3 class="box-title">Atendimentos</h3>
                                            <div class="box-tools pull-right">
                                                <button type="button" class="btn btn-box-tool" data-widget="collapse">
                                                    <i class="fa fa-plus"></i>
                                                </button>
                                            </div>
                                        </div>
                                        <!-- /.box-header -->
                                        <div class="box-body">
                                            <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped">
                                                <thead>
                                                    <tr role="row">
                                                        <th style="width: 90%">Funcionalidade</th>
                                                        <th style="width: 10%">Ativar</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr class="even" role="row">
                                                        <td>SOLICITAR</td>
                                                        <td>
                                                            <label class="container-checks">
                                                                <input type="checkbox" v-model="dados.permissoes" value="solicitacao.write" @click="() => {}" />
                                                                <span class="checkmark"></span>
                                                            </label>
                                                        </td>
                                                    </tr>
                                                    <tr class="even" role="row">
                                                        <td>VERIFICAR SOLITAÇÃO</td>
                                                        <td>
                                                            <label class="container-checks">
                                                                <input type="checkbox" v-model="dados.permissoes" value="solicitacao.read" @click="() => {}" />
                                                                <span class="checkmark"></span>
                                                            </label>
                                                        </td>
                                                    </tr>
                                                    <tr class="even" role="row">
                                                        <td>CANCELAR SOLICITAÇÃO</td>
                                                        <td>
                                                            <label class="container-checks">
                                                                <input type="checkbox" v-model="dados.permissoes" value="solicitacao.cancelar" @click="() => {}" />
                                                                <span class="checkmark"></span>
                                                            </label>
                                                        </td>
                                                    </tr>
                                                    <tr class="even" role="row">
                                                        <td>REGULAR SOLICITAÇÃO</td>
                                                        <td>
                                                            <label class="container-checks">
                                                                <input type="checkbox" v-model="dados.permissoes" value="solicitacao.regular" @click="() => {}" />
                                                                <span class="checkmark"></span>
                                                            </label>
                                                        </td>
                                                    </tr>
                                                    <tr class="even" role="row">
                                                        <td>ATENDIDO/FALTA</td>
                                                        <td>
                                                            <label class="container-checks">
                                                                <input type="checkbox" v-model="dados.permissoes" value="solicitacao.atendidoFalta" @click="() => {}" />
                                                                <span class="checkmark"></span>
                                                            </label>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <!-- /.box-body -->
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="box box-solid collapsed-box" style="font-size:12px;">
                                        <div class="box-header with-border">
                                            <h3 class="box-title">Cadastros</h3>
                                            <div class="box-tools pull-right">
                                                <button type="button" class="btn btn-box-tool" data-widget="collapse">
                                                    <i class="fa fa-plus"></i>
                                                </button>
                                            </div>
                                        </div>
                                        <!-- /.box-header -->
                                        <div class="box-body">
                                            <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped">
                                                <thead>
                                                    <tr role="row">
                                                        <th style="width: 80%">Funcionalidade</th>
                                                        <th style="width: 10%">Ativar</th>
                                                        <th style="width: 10%">Atualizar Dados</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr class="even" role="row">
                                                        <td>PACIENTES</td>
                                                        <td>
                                                            <label class="container-checks">
                                                                <input type="checkbox" v-model="dados.permissoes" value="paciente.read" @click="() => {}" />
                                                                <span class="checkmark"></span>
                                                            </label>
                                                        </td>
                                                        <td>
                                                            <label class="container-checks">
                                                                <input type="checkbox" v-model="dados.permissoes" value="paciente.write" @click="() => {}" />
                                                                <span class="checkmark"></span>
                                                            </label>
                                                        </td>
                                                    </tr>
                                                    <tr class="even" role="row">
                                                        <td>PROFISSIONAIS</td>
                                                        <td>
                                                            <label class="container-checks">
                                                                <input type="checkbox" v-model="dados.permissoes" value="profissional.read" @click="() => {}" />
                                                                <span class="checkmark"></span>
                                                            </label>
                                                        </td>
                                                        <td>
                                                            <label class="container-checks">
                                                                <input type="checkbox" v-model="dados.permissoes" value="profissional.write" @click="() => {}" />
                                                                <span class="checkmark"></span>
                                                            </label>
                                                        </td>
                                                    </tr>

                                                    <tr class="even" role="row">
                                                        <td>UNIDADES</td>
                                                        <td>
                                                            <label class="container-checks">
                                                                <input type="checkbox" v-model="dados.permissoes" value="unidade.read" @click="() => {}" />
                                                                <span class="checkmark"></span>
                                                            </label>
                                                        </td>
                                                        <td>
                                                            <label class="container-checks">
                                                                <input type="checkbox" v-model="dados.permissoes" value="unidade.write" @click="() => {}" />
                                                                <span class="checkmark"></span>
                                                            </label>
                                                        </td>
                                                    </tr>
                                                    <tr class="even" role="row">
                                                        <td>GRUPOS</td>
                                                        <td>
                                                            <label class="container-checks">
                                                                <input type="checkbox" v-model="dados.permissoes" value="grupo.read" @click="() => {}" />
                                                                <span class="checkmark"></span>
                                                            </label>
                                                        </td>
                                                        <td>
                                                            <label class="container-checks">
                                                                <input type="checkbox" v-model="dados.permissoes" value="grupo.write" @click="() => {}" />
                                                                <span class="checkmark"></span>
                                                            </label>
                                                        </td>
                                                    </tr>
                                                    <tr class="even" role="row">
                                                        <td>SUBGRUPOS</td>
                                                        <td>
                                                            <label class="container-checks">
                                                                <input type="checkbox" v-model="dados.permissoes" value="subgrupo.read" @click="() => {}" />
                                                                <span class="checkmark"></span>
                                                            </label>
                                                        </td>
                                                        <td>
                                                            <label class="container-checks">
                                                                <input type="checkbox" v-model="dados.permissoes" value="subgrupo.write" @click="() => {}" />
                                                                <span class="checkmark"></span>
                                                            </label>
                                                        </td>
                                                    </tr>
                                                    <tr class="even" role="row">
                                                        <td>FORMAS DE ORGANIZAÇÃO</td>
                                                        <td>
                                                            <label class="container-checks">
                                                                <input type="checkbox" v-model="dados.permissoes" value="forma.organizacao.read" @click="() => {}" />
                                                                <span class="checkmark"></span>
                                                            </label>
                                                        </td>
                                                        <td>
                                                            <label class="container-checks">
                                                                <input type="checkbox" v-model="dados.permissoes" value="forma.organizacao.write" @click="() => {}" />
                                                                <span class="checkmark"></span>
                                                            </label>
                                                        </td>
                                                    </tr>
                                                    <tr class="even" role="row">
                                                        <td>PROCEDIMENTOS</td>
                                                        <td>
                                                            <label class="container-checks">
                                                                <input type="checkbox" v-model="dados.permissoes" value="procedimento.read" @click="() => {}" />
                                                                <span class="checkmark"></span>
                                                            </label>
                                                        </td>
                                                        <td>
                                                            <label class="container-checks">
                                                                <input type="checkbox" v-model="dados.permissoes" value="procedimento.write" @click="() => {}" />
                                                                <span class="checkmark"></span>
                                                            </label>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <!-- /.box-body -->
                                    </div>
                                </div>
                            </div>
							<div class="row">
								<div class="col-sm-12">
									<div class="box box-solid collapsed-box" style="font-size:12px;">
										<div class="box-header with-border">
											<h3 class="box-title">Integração com o sistema Antigo</h3>
											<div class="box-tools pull-right">
												<button type="button" class="btn btn-box-tool" data-widget="collapse">
													<i class="fa fa-plus"></i>
												</button>
											</div>
										</div>
										<!-- /.box-header -->
										<div class="box-body">
											<table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped">
												<thead>
												<tr role="row">
													<th style="width: 80%">Funcionalidade</th>
													<th style="width: 10%">Ativar</th>
													<th style="width: 10%">Atualizar Dados</th>
												</tr>
												</thead>
												<tbody>
												<tr class="even" role="row">
													<td>PACIENTES</td>
													<td>
														<label class="container-checks">
															<input type="checkbox" v-model="dados.permissoes" value="paciente-integracao.read" @click="() => {}" />
															<span class="checkmark"></span>
														</label>
													</td>
													<td>
														<label class="container-checks">
															<input type="checkbox" v-model="dados.permissoes" value="paciente-integracao.write" @click="() => {}" />
															<span class="checkmark"></span>
														</label>
													</td>
												</tr>
												</tbody>
											</table>
										</div>
										<!-- /.box-body -->
									</div>
								</div>
							</div>
                            <div class="box-footer text-right">
                                <router-link tag="a" to="/cadastros/usuarios" class="btn btn-default">Voltar</router-link>
                                <input style="text-transform:none !important" class="btn btn-primary" type="submit" value="Salvar" :disabled="finalizado" />
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import axios from "axios";
import { mask } from "vue-the-mask";
export default {
    directives: {
        mask
    },
    data: () => ({
        finalizado: false,
        viewPermissions: true,
        dados: {
            id: null,
            name: "",
            login: "",
            email: "",
            telefone: "",
            anotacoes: "",
            password: "",
            nivel: "",
            setor_id: null,
            permissoes: [],
            unidades: []
        },
        confirmacaoSenha: "",
        atualizacao: false,

        selectUnidades: []
    }),
    mounted() {
        this.getUnidades();
        if (this.$route.params.idUsuario) {
            this.getUserById(this.$route.params.idUsuario);
            this.atualizacao = true;
            this.viewPermissions = false;
        }
    },
    methods: {
        getUserById(id) {
            this.$store.commit("TOGGLE_LOADING");
            axios
                .get(`${this.$store.state.serverURI}/api/usuario/getById/` + id, this.$store.getters.getHeaderAuth)
                .then(response => {
                    this.dados.id = response.data.id;
                    this.dados.name = response.data.name;
                    this.dados.login = response.data.login;
                    this.dados.email = response.data.email;
                    this.dados.setor_id = response.data.setor_id;
                    this.dados.permissoes = response.data.permissoes;
                    this.dados.nivel = response.data.nivel;
                    this.dados.situacao = response.data.situacao;
                    this.dados.telefone = response.data.telefone;
                    this.dados.anotacoes = response.data.anotacoes;
                    var stringified = JSON.stringify(response.data.unidades);
                    stringified = stringified.replace(/nome/g, "label");
                    stringified = stringified.replace(/id/g, "value");
                    this.dados.unidades = JSON.parse(stringified);
                    this.$store.commit("TOGGLE_LOADING");
                })
                .catch(error => {
                    this.$store.commit("SHOW_ALERT_ERROR");
                    this.$store.commit("SET_ALERT_MESSAGE", error.response.data.message);
                    this.$router.push("/cadastros/usuarios");
                    console.log(error);
                });
        },
        getUnidades() {
            this.$store.commit("TOGGLE_LOADING");
            axios
                .get(`${this.$store.state.serverURI}/api/cadastros/unidades/dataForSelect/`, this.$store.getters.getHeaderAuth)
                .then(response => {
                    let unidades = response.data;

                    var stringified = JSON.stringify(response.data);
                    stringified = stringified.replace(/nome/g, "label");
                    stringified = stringified.replace(/id/g, "value");

                    unidades = JSON.parse(stringified);

                    this.selectUnidades = unidades;
                    this.$store.commit("TOGGLE_LOADING");
                })
                .catch(error => {
                    this.$store.commit("SHOW_ALERT_ERROR");
                    this.$store.commit("SET_ALERT_MESSAGE", error.response.data.message);
                    this.$router.push("/cadastros/usuarios");
                    console.log(error);
                });
        },
        commit() {
            this.$validator.validateAll().then(result => {
                if (result) {
                    this.finalizado = true;
                    this.$store.commit("TOGGLE_LOADING");
                    if (this.atualizacao) {
                        axios
                            .post(`${this.$store.state.serverURI}/api/usuario/update/` + this.dados.id, this.dados, this.$store.getters.getHeaderAuth)
                            .then(response => {
                                this.$store.commit("SHOW_ALERT_SUCCESS");
                                this.$router.push("/cadastros/usuarios");
                            })
                            .catch(error => {
                                this.$store.commit("SHOW_ALERT_ERROR");
                                this.finalizado = false;
                                console.log(error);
                            });
                    } else {
                        axios
                            .post(`${this.$store.state.serverURI}/api/usuario/create`, this.dados, this.$store.getters.getHeaderAuth)
                            .then(response => {
                                this.$store.commit("SHOW_ALERT_SUCCESS");
                                this.$router.push("/cadastros/usuarios");
                            })
                            .catch(error => {
                                this.$store.commit("SHOW_ALERT_ERROR");
                                this.finalizado = false;
                                console.log(error);
                            });
                    }
                }
                this.$store.commit("TOGGLE_LOADING");
                return false;
            });
        }
    }
};
</script>

<style scoped>
form {
    padding: 0;
}
.box-title {
    font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// Form.vue?2c5027c9